import React from "react";
import IndustrialPipe from "../../assets/abouthero.png";

export const Hero = () => {
    return (
        <section className="w-full min-h-[85vh] flex items-center bg-primary-50 pt-5">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
                {/* LEFT CONTENT */}
                <div className="text-center md:text-left">
                    <h1 className="text-3xl sm:text-4xl md:text-6xl  font-bold text-gray-900 leading-tight">
                        About Vetri Pipeline<br />
                         Systems Pvt. Ltd.
                    </h1>

                    <p className="mt-4 text-gray-600 text-sm sm:text-base max-w-md mx-auto md:mx-0">
                        Delivering reliable industrial fabrication, pipeline, and boiler erection solutions with a commitment to quality, safety, and engineering excellence.
                    </p>

                    {/* Buttons */}
                    <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                        <button className="bg-primary-500 text-white px-6 py-3 rounded-lg hover:bg-primary-600 transition">
                            Get Started
                        </button>

                        <button className="border border-primary-500 text-primary-500 px-6 py-3 rounded-lg hover:bg-primary-100 transition">
                            Learn more
                        </button>
                    </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className="flex justify-center md:justify-end">
                    <img
                        src={IndustrialPipe}
                        alt="industrial pipeline"
                        className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl rounded-2xl shadow-lg object-cover hover:scale-105 transition duration-300"
                    />
                </div>
            </div>
        </section>
    );
};